var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"display-grid w-100v h-100v",attrs:{"id":"blank-layout"}})
}
var staticRenderFns = []

export { render, staticRenderFns }